const preferencesTypes = {

  index: {
    request: "PREFERENCES_INDEX_REQUEST",
    success: "PREFERENCES_INDEX_SUCCESS",
    failure: "PREFERENCES_INDEX_FAILURE"
  },

  update: {
    request: "UPDATE_PREFERENCES_REQUEST",
    success: "UPDATE_PREFERENCES_SUCCESS",
    failure: "UPDATE_PREFERENCES_FAILURE"
  },

  set_errors: "SET_PREFERENCES_ERRORS",

  reset: "RESET_PREFERENCE"

}

export default preferencesTypes



// WEBPACK FOOTER //
// ./src/js/constants/preferencesTypes.js